
export const Form_Name = {
    'en': 'Smart Link',
    'ko': '스마트 링크'
    // 다른 언어 추가 가능
};



export const Form_Connect = {
    'en': 'Smart Link connect [URL] username [USR] password [PWS]',
    'ko': '커스텀 연결 :[URL] 아이디:[USR] 비밀번호:[PWS]',
};
export const Form_Auto_Connect = {
    'en': 'Smart Link connect',
    'ko': '스마트 링크 연결',
};

export const Form_Connect_off = {
    'en': 'close connection',
    'ko': '연결 끊기',
};

export const Form_getConnectState = {
    'en': 'connection status',
    'ko': '연결 상태',
};

export const Form_isconnect = {
    'en': 'connected',
    'ko': '연결 됨',
};
export const Form_disconnect = {
    'en': 'disconnect',
    'ko': '연결 끊김',
};



export const Form_Publish_Topic = {
    'en': 'publish topic [TOPIC] message [PUBLISH]',
    'ko': '채널 [TOPIC] 에 [PUBLISH] 보내기',
};

export const Form_Subscribe_Topic = {
    'en': 'listen channel [TOPIC]',
    'ko': '채널 듣기 [TOPIC]',
};


export const Form_FormDmqttTopic ={
    'en': 'received channel',
    'ko': '받은 채널',
}

export const Form_FormDmqttMsg = {
    'en': 'received message',
    'ko': '받은 메시지',
};

export const Form_ClearMsg = {
    'en': 'clear message',
    'ko': '메시지 지우기',
};


// 채널 듣기 해제
export const Form_Unsubscribe_Topic = {
    'en': 'leave channel [TOPIC]',
    'ko': '채널 나가기 [TOPIC]',
};
